import React from 'react';
import { FaAngleRight } from 'react-icons/fa6';

import Button, { ButtonAppearance } from '../../../../../ui/Atoms/Button';
import DropdownMenu from '../../../../../ui/Molecules/DropdownMenu';
import { HeaderSection } from '../HeaderSection';

import * as S from './WebsiteNavigationDesktop.styles';

export const WebsiteNavigationDesktop = ({
  websiteDropdowns,
  headerAriaLabel,
}) => {
  return (
    <S.MenuContainer>
      {websiteDropdowns.map(
        ({ title, moreLabel, moreLink, sections }, index) => {
          if (!title || !sections) return null;

          const hasMoreButton = !!moreLink.url && !!moreLabel;
          const headerSections = sections || [];

          return (
            <DropdownMenu
              title={title}
              ariaLabel={`${headerAriaLabel || 'Discover our page:'} ${title}`}
              key={index}
            >
              {headerSections.length > 0 && (
                <S.SectionWrapper>
                  {headerSections.map((section, index) => (
                    <HeaderSection
                      key={index}
                      section={section}
                      hasMoreButton={hasMoreButton}
                    />
                  ))}
                </S.SectionWrapper>
              )}
              {moreLink.url && moreLabel && (
                <S.MoreButtonWrapper>
                  <Button
                    appearance={ButtonAppearance.MINIMAL}
                    link={moreLink.url}
                    target={moreLink.target}
                  >
                    {moreLabel}
                    <FaAngleRight />
                  </Button>
                </S.MoreButtonWrapper>
              )}
            </DropdownMenu>
          );
        }
      )}
    </S.MenuContainer>
  );
};
